import { Injectable, signal } from '@angular/core';
import { StringOutputParser } from '@langchain/core/output_parsers';
import { ChatPromptTemplate } from '@langchain/core/prompts';
import { ChatOpenAI } from '@langchain/openai';
import { assistant } from '@runnables';
import { OpenAI } from 'openai';

const OPEN_API_KEY =
  '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';

@Injectable({
  providedIn: 'root',
})
export class AiTextService {
  answer = signal('');
  idle = signal(false);

  chatOpenAi = new ChatOpenAI({
    apiKey: OPEN_API_KEY,
  });

  openAi = new OpenAI({
    apiKey: OPEN_API_KEY,
    dangerouslyAllowBrowser: true,
  });

  thread = this.openAi.beta.threads.create();

  async sendMessage(question: string) {
    this.idle.set(true);
    const thread = await this.thread;
    const prompt = ChatPromptTemplate.fromTemplate(
      `Answer the following question as clearly as possible and without mentioning sources or references:\n\n${question}`,
    );

    const composedChain = prompt
      .pipe((prompt) => {
        return prompt.messages[0].content;
      })
      .pipe((prompt: any) => assistant(prompt, this.openAi, thread))
      .pipe((response: any) => {
        return new StringOutputParser().invoke(response);
      });

    const response = await composedChain.invoke({ question });
    this.idle.set(false);

    const cleaned = response.replace(/```html|```/g, '');
    this.answer.set(cleaned);
  }
}
